import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
import Swal from "sweetalert2";
import { motion } from 'framer-motion';
import { Users, Copy, ChevronRight } from 'lucide-react';

const MembersLayer = () => {
  const [uName, setUName] = useState("");
  const [MembersLayerData, setMemberLayerData] = useState(null);
  const memberRefID = `postperty.co/register?ID=${uName}`;
  const token = Cookies.get("jwt");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/user/getDataProfile`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setUName(res.data.uname))
      .catch((error) => console.error(error));
  }, [token]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/mlm/invited`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setMemberLayerData(res.data))
      .catch((error) => console.error(error));
  }, [token]);

  const copyLinkInvite = async () => {
    await navigator.clipboard.writeText(memberRefID);
    Swal.fire("คัดลอกสำเร็จ", "สามารถนำลิงค์นี้แชร์ให้เพื่อนของคุณได้", "success");
  };

  return (
    <div className="min-h-screen bg-gray-50 lg:pt-20">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <Link to="/profiles">
            <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
          </Link>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">โปรไฟล์</p>
            <h1 className="text-lg font-bold text-gray-900">สมาชิกของฉัน</h1>
          </div>
        </motion.div>

        {/* Total Members Card */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.04 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-6 py-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">สมาชิกทั้งหมด</p>
          <div className="flex items-baseline gap-2">
            <span className="text-4xl font-bold text-blue-600">
              {MembersLayerData ? MembersLayerData.Overall_Invited : '0'}
            </span>
            <span className="text-base text-gray-400 font-medium flex items-center gap-1">
              <Users className="w-4 h-4" /> คน
            </span>
          </div>
        </motion.div>

        {/* Copy invite link */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.06 }}
        >
          <button
            onClick={copyLinkInvite}
            className="w-full flex items-center justify-center gap-2 py-3 bg-blue-600 text-white text-sm font-semibold rounded-2xl hover:bg-blue-700 transition-colors"
          >
            <Copy className="w-4 h-4" />
            คัดลอกลิงค์เชิญ
          </button>
        </motion.div>

        {/* Layer list */}
        <div className="space-y-2">
          {Array.from({ length: 5 }, (_, i) => (
            MembersLayerData && MembersLayerData.TotalLayer[`L${i + 1}`] !== undefined && (
              <motion.div
                key={i + 1}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: 0.08 + i * 0.05 }}
              >
                <Link
                  to={`/members/layer/desc?data=${i + 1}`}
                  className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-11 h-11 bg-blue-600 rounded-xl flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                      {i + 1}
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 mb-0.5">ชั้นที่ {i + 1}</p>
                      <p className={`text-sm font-semibold ${MembersLayerData.TotalLayer[`L${i + 1}`] === 0 ? 'text-gray-400' : 'text-gray-800'}`}>
                        {MembersLayerData.TotalLayer[`L${i + 1}`] === 0
                          ? 'ไม่มีสมาชิกในชั้นนี้'
                          : `สมาชิก ${MembersLayerData.TotalLayer[`L${i + 1}`]} คน`}
                      </p>
                    </div>
                  </div>
                  <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
                </Link>
              </motion.div>
            )
          ))}
        </div>

        <div className="h-8" />
      </div>
    </div>
  );
};

export default MembersLayer;
